import React from 'react';
import styles from './Tabs.module.scss';
import { BET_SLIP_TABS } from '../../../constants/defaultValues';
import { useDispatch, useSelector } from 'react-redux';
import { changeBetSlipActiveTab } from '../../../store/actions/betSlip';

const Tabs = () => {
    const dispatch = useDispatch();

    const betLines = useSelector(state => state.betSlip.betLines);
    const activeTab = useSelector(state => state.betSlip.activeTab);
    const disabledTabs = useSelector(state => state.betSlip.disabledTabs);

    const onTabClick = tabId => {
        dispatch(changeBetSlipActiveTab(tabId));
    };

    return (
        <div className={styles.tabs}>
            {Object.values(BET_SLIP_TABS).map(tab => {
                const isDisabled = disabledTabs.find(t => t === tab.id);
                const isActive = tab.id === activeTab;

                return (
                    <button
                        className={`${styles.tabButton} ${isActive ? styles.active : ''}`}
                        key={tab.id}
                        onClick={() => onTabClick(tab.id)}
                        disabled={isDisabled}
                    >
                        {tab.name} {isActive && betLines.length > 0 ? `(${betLines.length})` : ''}
                    </button>
                );
            })}
        </div>
    );
};

export default Tabs;
